import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import Content from 'components/Content';
import SearchBar from 'components/common/SearchBar';
import BundleTypeBar from 'components/common/BundleTypeBar';
import BundleItem from 'components/bundles/BundleItem';
import TemplateItem from 'components/templates/TemplateItem';
import { asyncSearchForBundles, preloadBundle } from 'actions/bundles';
import { asyncSearchForTemplates, preloadTemplate } from 'actions/templates';
import { asyncSearchForHome } from 'actions/home';
import { selectBundleType } from 'actions/user';
import * as Const from 'util/constants';
import './Home.scss';
import '@fortawesome/fontawesome-free/css/all.min.css';

export class Home extends Component {
  componentDidMount() {
    const { query } = this.props.match.params;
    const { isLoading, searchForHome, setBundleType } = this.props;
    document.title = 'Doodle & Cartoon Images & Vectors';
    setBundleType('');
    if (!isLoading) searchForHome(query || '');
  }

  viewMore = type => {
    const query = this.props.match.params.query || '';
    const { searchForBundles, searchForTemplates, history } = this.props;
    switch (type) {
      case Const.TYPE_IMAGE_BUNDLES:
        history.push(`/${Const.TYPE_IMAGE_BUNDLES}/${query}`);
        searchForBundles(query, Const.TYPE_IMAGE_BUNDLES);
        break;
      case Const.TYPE_AUDIO_BUNDLES:
        history.push(`/${Const.TYPE_AUDIO_BUNDLES}/${query}`);
        searchForBundles(query, Const.TYPE_AUDIO_BUNDLES);
        break;
      case Const.TYPE_TEMPLATES:
        history.push(`/${Const.TYPE_TEMPLATES}/${query}`);
        searchForTemplates(query, Const.TYPE_TEMPLATES);
        break;
      default:
    }
  };

  render() {
    const { imageBundles, audioBundles, templates, isLoading, loadBundle, loadTemplate } = this.props;
    return (
      <div className="home d-flex flex-column">
        <Header />
        <Content>
          <div className="top-content d-flex flex-column align-items-center">
            <h1 className="text-center">Welcome To The Doodly Marketplace!</h1>
            <h3 className="text-center">To get started, click a category or enter a topic into the search box below</h3>
            <BundleTypeBar />
            <SearchBar className="home" />
          </div>
          <div className="sheet">
            {(imageBundles && imageBundles.length > 0) ||
            (audioBundles && audioBundles.length > 0) ||
            (templates && templates.length > 0) ? (
              <>
                {imageBundles && imageBundles.length > 0 && (
                  <div className="bundle-container d-flex flex-column">
                    <h2 className="text-left mt-3 mb-5">Featured Doodly Image Bundles</h2>
                    <div className="list d-flex flex-wrap">
                      {imageBundles.map((bundle, i) => (
                        <BundleItem key={i} bundle={bundle} className="col-md-6 col-lg-3" onSelect={loadBundle} />
                      ))}
                    </div>
                    {imageBundles && imageBundles.length > 0 && (
                      /* hasMore && */ <button
                        className="btn btn-view-more-image align-self-center mb-5"
                        onClick={() => this.viewMore(Const.TYPE_IMAGE_BUNDLES)}
                      >
                        View more
                      </button>
                    )}
                  </div>
                )}
                <div className="row">
                  {audioBundles && audioBundles.length > 0 && (
                    <div className="bundle-container d-flex flex-column col-lg-6">
                      <h2 className="text-left mt-3 mb-5">Featured Audio Bundles</h2>
                      <div className="list d-flex flex-wrap">
                        {audioBundles.map((bundle, i) => (
                          <BundleItem key={i} bundle={bundle} className="col-md-6 col-lg-6" onSelect={loadBundle} />
                        ))}
                      </div>
                      {audioBundles && audioBundles.length > 0 && (
                        /* hasMore && */ <button
                          className="btn btn-view-more align-self-center mb-5"
                          onClick={() => this.viewMore(Const.TYPE_AUDIO_BUNDLES)}
                        >
                          View more
                        </button>
                      )}
                    </div>
                  )}
                  {templates && templates.length > 0 && (
                    <div className="bundle-container d-flex flex-column col-lg-6">
                      <h2 className="text-left mt-3 mb-5">Featured Templates</h2>
                      <div className="list d-flex flex-wrap">
                        {templates.map((template, i) => (
                          <TemplateItem
                            key={i}
                            template={template}
                            className="col-md-6 col-lg-6"
                            onSelect={loadTemplate}
                          />
                        ))}
                      </div>
                      {templates && templates.length > 0 && (
                        /* hasMore && */ <button
                          className="btn btn-view-more align-self-center mb-5"
                          onClick={() => this.viewMore(Const.TYPE_TEMPLATES)}
                        >
                          View more
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </>
            ) : (
              !isLoading && <p className="ml-3">No bundle found matching your criteria.</p>
            )}
            {isLoading && (
              <div className="loading">
                <i className="fas fa-spinner fa-spin" />
              </div>
            )}
          </div>
        </Content>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { imageBundles, audioBundles, templates, isLoading, searchFor } = state.home;
  return {
    imageBundles,
    audioBundles,
    templates,
    isLoading,
    searchFor
  };
};

const mapDispatchToProps = dispatch => ({
  // reset: () => dispatch(resetSettings()),
  searchForBundles: (term, type) => dispatch(asyncSearchForBundles(term, type)),
  searchForTemplates: (term, type) => dispatch(asyncSearchForTemplates(term, type)),
  searchForHome: term => dispatch(asyncSearchForHome(term)),
  loadBundle: bundle => dispatch(preloadBundle(bundle)),
  loadTemplate: template => dispatch(preloadTemplate(template)),
  setBundleType: type => dispatch(selectBundleType(type))
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
